"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const catalog_setting_1 = require("./emerch/catalog-setting");
const abtests_client_1 = require("./abtests.client");
const accounts_client_1 = require("./accounts.client");
const alert_client_1 = require("./alert.client");
const api_keys_client_1 = require("./api-keys.client");
const auth_client_1 = require("./auth.client");
const auto_insight_client_1 = require("./auto-insight.client");
const bookmarks_client_1 = require("./bookmarks.client");
const brands_1 = require("./emerch/brands");
const catalog_1 = require("./emerch/catalog");
const category_1 = require("./emerch/category");
const metric_1 = require("./emerch/metric");
const competitive_data_1 = require("./emerch/competitive-data");
const customer_client_1 = require("./customer.client");
const dashboard_client_1 = require("./dashboard.client");
const dashboard_client_v2_1 = require("./dashboard.client.v2");
const dashboard_user_context_client_v2_1 = require("./dashboard-user-context.client.v2");
const form_client_1 = require("./form.client");
const goal_client_1 = require("./goal.client");
const heatmap_client_1 = require("./heatmap.client");
const heatmap_client_v2_1 = require("./heatmap.client.v2");
const identity_provider_client_1 = require("./identity-provider.client");
const integrations_v2_client_1 = require("./integrations.v2.client");
const integrations_client_1 = require("./integrations.client");
const js_errors_client_1 = require("./js-errors.client");
const log_client_1 = require("./log.client");
const mapping_client_1 = require("./mapping.client");
const metrics_client_1 = require("./metrics.client");
const metrics_client_v2_1 = require("./metrics.client.v2");
const oauth_client_1 = require("./oauth.client");
const partner_client_1 = require("./partner.client");
const product_1 = require("./emerch/product");
const project_client_1 = require("./project.client");
const projects_benchmark_client_1 = require("./projects-benchmark.client");
const recording_client_1 = require("./recording.client");
const recording_client_v2_1 = require("./recording.client.v2");
const recording_client_v3_1 = require("./recording.client.v3");
const recording_client_v4_1 = require("./recording.client.v4");
const segment_client_1 = require("./segment.client");
const session_replay_client_1 = require("./session-replay.client");
const snapshot_client_1 = require("./snapshot.client");
const snapshot_client_v2_1 = require("./snapshot.client.v2");
const team_client_1 = require("./team.client");
const uxa_context_client_1 = require("./uxa-context.client");
const user_client_1 = require("./user.client");
const user_v2_client_1 = require("./user.v2.client");
const vars_client_1 = require("./vars.client");
const widget_client_v2_1 = require("./widget.client.v2");
const zone_client_1 = require("./zone.client");
const zoning_client_1 = require("./zoning.client");
const auth_v2_client_1 = require("./auth.v2.client");
const identity_provider_v2_client_1 = require("./identity-provider.v2.client");
const sso_early_access_client_1 = require("./sso-early-access.client");
__export(require("./abtests.client"));
__export(require("./accounts.client"));
__export(require("./alert.client"));
__export(require("./api-keys.client"));
__export(require("./auto-insight.client"));
__export(require("./base.client"));
__export(require("./bookmarks.client"));
__export(require("./auth.client"));
__export(require("./customer.client"));
__export(require("./dashboard.client"));
__export(require("./dashboard.client.v2"));
__export(require("./dashboard-user-context.client.v2"));
__export(require("./form.client"));
__export(require("./goal.client"));
__export(require("./heatmap.client"));
__export(require("./heatmap.client.v2"));
__export(require("./identity-provider.client"));
__export(require("./integrations.client"));
__export(require("./js-errors.client"));
__export(require("./log.client"));
__export(require("./mapping.client"));
__export(require("./metrics.client"));
__export(require("./metrics.client.v2"));
__export(require("./partner.client"));
__export(require("./project.client"));
__export(require("./projects-benchmark.client"));
__export(require("./recording.client"));
__export(require("./recording.client.v2"));
__export(require("./recording.client.v3"));
__export(require("./recording.client.v4"));
__export(require("./segment.client"));
__export(require("./snapshot.client"));
__export(require("./snapshot.client.v2"));
__export(require("./team.client"));
__export(require("./user.client"));
__export(require("./user.v2.client"));
__export(require("./uxa-context.client"));
__export(require("./vars.client"));
__export(require("./widget.client.v2"));
__export(require("./zone.client"));
__export(require("./zoning.client"));
__export(require("./oauth.client"));
__export(require("./integrations.v2.client"));
__export(require("./session-replay.client"));
__export(require("./auth.v2.client"));
__export(require("./identity-provider.v2.client"));
__export(require("./sso-early-access.client"));
__export(require("./emerch/brands"));
__export(require("./emerch/category"));
__export(require("./emerch/catalog"));
__export(require("./emerch/product"));
__export(require("./emerch/competitive-data"));
__export(require("./emerch/catalog-setting"));
__export(require("./emerch/metric"));
const emerchClientsV2 = [
    brands_1.BrandClientV2,
    category_1.CategoryClientV2,
    catalog_1.CatalogClientV2,
    product_1.ProductClientV2,
    competitive_data_1.CompetitiveDataClientV2,
    catalog_setting_1.CatalogSettingClientV2,
    metric_1.CatalogMetricsClient,
    metric_1.PerformanceMetricClient,
];
exports.AllClients = [
    abtests_client_1.ABTestClient,
    accounts_client_1.AccountsClient,
    alert_client_1.AlertClient,
    api_keys_client_1.ApiKeysClient,
    auth_client_1.AuthClient,
    auto_insight_client_1.AutoInsightClient,
    bookmarks_client_1.BookmarksClient,
    customer_client_1.CustomerClient,
    dashboard_client_1.DashboardClient,
    dashboard_client_v2_1.DashboardClientV2,
    dashboard_user_context_client_v2_1.DashboardUserContextClientV2,
    ...emerchClientsV2,
    form_client_1.FormClient,
    goal_client_1.GoalClient,
    heatmap_client_1.HeatmapClient,
    heatmap_client_v2_1.HeatmapClientV2,
    identity_provider_client_1.IdentityProviderClient,
    integrations_client_1.IntegrationsClient,
    log_client_1.LogClient,
    mapping_client_1.MappingClient,
    metrics_client_1.MetricsClient,
    metrics_client_v2_1.MetricsClientV2,
    partner_client_1.PartnerClient,
    project_client_1.ProjectClient,
    projects_benchmark_client_1.ProjectsBenchmarkClient,
    recording_client_1.RecordingClient,
    recording_client_v2_1.RecordingClientV2,
    recording_client_v3_1.RecordingClientV3,
    recording_client_v4_1.RecordingClientV4,
    segment_client_1.SegmentClient,
    snapshot_client_1.SnapshotClient,
    snapshot_client_v2_1.SnapshotClientV2,
    catalog_setting_1.CatalogSettingsClient,
    team_client_1.TeamClient,
    user_client_1.UserClient,
    user_v2_client_1.UserV2Client,
    uxa_context_client_1.UXAContextClient,
    vars_client_1.VarsClient,
    widget_client_v2_1.WidgetClientV2,
    zone_client_1.ZoneClient,
    zoning_client_1.ZoningClient,
    js_errors_client_1.JSErrorsClient,
    oauth_client_1.OAuthClient,
    integrations_v2_client_1.IntegrationV2Client,
    session_replay_client_1.SessionReplayClient,
    auth_v2_client_1.AuthV2Client,
    identity_provider_v2_client_1.IdentityProviderV2Client,
    sso_early_access_client_1.SsoEarlyAccessClient,
];
//# sourceMappingURL=index.js.map